export const PermissionTemplateApiPath = {
  LIST_PERMISSION_TEMPLATES: '/api/sites/{site_id}/permission-templates', // GET List Permission Templates
  CREATE_PERMISSION_TEMPLATE: '/api/sites/{site_id}/permission-templates', // POST Create Permission Template
  UPDATE_PERMISSION_TEMPLATE: '/api/sites/{site_id}/permission-templates/{template_id}', // PUT Update Permission Template
  DELETE_PERMISSION_TEMPLATE: '/api/sites/{site_id}/permission-templates/{template_id}' // DELETE Delete Permission Template
}

export type PermissionTemplateApiPath =
  (typeof PermissionTemplateApiPath)[keyof typeof PermissionTemplateApiPath]

export interface ListPermissionTemplatesVars {
  site_id: number
}

export interface CreatePermissionTemplateVars {
  site_id: number
  name: string
  menu_permissions?: Record<string, unknown>
  can_approve_article?: boolean
}

export interface UpdatePermissionTemplateVars {
  site_id: number
  template_id: number
  name?: string | null
  menu_permissions?: Record<string, unknown> | null
  can_approve_article?: boolean | null
}

export interface DeletePermissionTemplateVars {
  site_id: number
  template_id: number
}

import { PermissionTemplate } from '@/common/model/auth'

export type ListPermissionTemplatesResponse = PermissionTemplate[]
export type CreatePermissionTemplateResponse = PermissionTemplate
export type UpdatePermissionTemplateResponse = PermissionTemplate

export interface DeletePermissionTemplateResponse {
  ok: boolean
}
